import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import RouteIcon from "@mui/icons-material/Route";
import { IFieldConfig } from "@components/Form/interface/form.interfaces";

interface HeroCardConfigDeps {
  onCreateCompany: () => void;
  onFindExpert: () => void;
  onLaunchEditor: () => void;
  isLoggedIn: boolean;
  hasCompanies: boolean;
}

export const flowHubHeroCardsConfig = ({ onCreateCompany, onFindExpert, onLaunchEditor, isLoggedIn, hasCompanies }: HeroCardConfigDeps) => {
  return [
    {
      title: "Find a Service",
      description: "Connect with verified proffesionals and digital experts for your next big project.",
      icon: <BusinessCenterIcon />,
      buttonLabel: "Get Started",
      // link: "/services",
      action: () => {
        onFindExpert();
      },
    },
    {
      title: isLoggedIn ? (hasCompanies ? "Manage a Company" : "Create a Company") : "Create a Company",
      description: "Access your dashboard to oversee operations, branding, and business infrastructure.",
      icon: <SettingsApplicationsIcon />,
      buttonLabel: isLoggedIn ? "Open Dashboard" : "Get Started",
      // link: "/business/organization"
      action: () => {
        onCreateCompany();
      },
    },
    // {
    //     title: "Job Opportunities",
    //     description: "Browse curated career listings and freelance gigs tailored to your specific skillset.",
    //     icon: <WorkIcon />,
    //     buttonLabel: "View Jobs",
    //     // link: "/jobs"
    // },
    {
      title: "Page Builder",
      description: "Design stunning landing pages and digital storefronts with our drag-and-drop editor",
      icon: <RouteIcon />,
      buttonLabel: "Launch Editor",
      // link: "/business/page-builder"
      action: () => {
        onLaunchEditor();
      },
    },
  ];
};

export const companyFormFields: IFieldConfig[] = [
  {
    name: "businessName",
    label: "Business Name",
    type: "text",
    required: true,
    placeholder: "Enter your business name",
  },
  {
    name: "businessPhone",
    label: "Business Phone",
    type: "text",
    required: true,
    placeholder: "Enter your business phone",
  },
  {
    name: "email",
    label: "Email",
    type: "email",
    required: true,
    placeholder: "Enter your business email",
  },
  {
    name: "employerId",
    label: "Employer ID",
    type: "text",
    placeholder: "Enter employer ID (optional)",
  },
  {
    name: "address",
    label: "Address",
    type: "address",
    required: true,
    placeholder: "Enter address",
    cols: 2,
    autocompleteOptions: {
      types: ["address"],
      componentRestrictions: { country: ["us", "mx"] },
    },
  },
  {
    name: "city",
    label: "City",
    type: "text",
    required: true,
    placeholder: "Enter city",
  },
  {
    name: "state",
    label: "State",
    type: "text",
    required: true,
    placeholder: "Enter state",
  },
  {
    name: "country",
    label: "Country",
    type: "text",
    required: true,
    placeholder: "Enter country",
  },
  {
    name: "zipCode",
    label: "Zip Code",
    type: "text",
    required: true,
    placeholder: "Enter zip code",
  },
];
